<div class="skeleton" [style.height]="skeletonHeight">
  <div
    *ngFor="let line of getLinesArray()"
    class="skeleton__line"
    [style.height]="height"
    [style.animation-delay]="delay + 's'"
    [class.circle]="rounded"
  ></div>
</div>
